
import { SearchSettings } from '../../typings/search-settings';

export const FretSearchSettings: SearchSettings = {
    facets: [
        {
            id: 'verfasser',
            titleDE: 'Verfasser',
            titleFR : 'Auteur',
            facetKeys: ['27_facet_verfasserFA', '28_facet_verfasserFA']
        },
        {
            id: 'empfanger',
            titleDE: 'Empfänger',
            titleFR: 'Destinataire',
            facetKeys: ['27_facet_empfaengerFA', '28_facet_empfaengerFA']
        },
        {
            id: 'schlagworter',
            titleDE: 'Schlagwörter',
            titleFR: 'Mots clés',
            facetKeys: ['27_facet_schlagwoerter', '28_facet_schlagwoerter']
        },
        {
            id: 'weitere_personen',
            titleDE: 'Weitere Personen',
            titleFR: 'Autres personnes',
            facetKeys: ['27_facet_personenFA', '28_facet_personenFA']
        },
        {
            id: 'geo_schlagwoerter',
            titleDE: 'Geographische Schlagwörter',
            titleFR: 'Mots clés géographique',
            facetKeys: ['27_facet_orteFA', '28_facet_orteFA']
        },
        {
            id: 'fundorte',
            titleDE: 'Fundorte',
            titleFR: 'Lieu',
            facetKeys: ['27_facet_bestand', '28_facet_bestand']
        },
        {
            id: 'vorlage',
            titleDE: 'Vorlage',
            titleFR: 'Nature du document',
            facetKeys: ['27_facet_or_en_ab', '28_facet_or_en_ab']
        },
        {
            id: 'jahr',
            titleDE: 'Jahr',
            titleFR: 'Année',
            facetKeys: ['27_facet_datum_year', '28_facet_datum_year']
        },
        // {
        //     id: 'jahr2',
        //     title: 'Datierung (Zeitraum)',
        //     facetKeys: ['28_datraum']
        // },
    ],
    validDocTypes: ['doctyp28', 'doctyp27']
};
